import { createArrayQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useCountryCard = createSharedComposable(() => {
    return createArrayQuery<string[]>('country-card', {
        normalize: value => {
            return value
                ? [
                      String(value[0] || ''),
                      ...value.slice(1).filter(Boolean)
                  ].filter(Boolean)
                : value
        }
    })
})
